import { Link } from 'react-router';
import { getAllBlogPosts } from '../../lib/blogs.js';
import { formatDate } from '../../lib/dateUtils.js';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

export default function BlogList() {
  useDocumentTitle('Blog');
  const posts = getAllBlogPosts();

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <h1>Blog</h1>
      <p className="meta">
        Written by club members. New posts are added by opening a pull request, see the
        contributing guide in the repository.
      </p>

      {posts.length === 0 ? (
        <p>No posts yet.</p>
      ) : (
        <ul className="hairline-list">
          {posts.map((post) => (
            <li key={post.slug}>
              <h2>
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="meta">
                {post.author} · {formatDate(post.publishedDate)}
              </p>
              {post.summary && <p>{post.summary}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
